const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrp(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1_1_",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 32,
    y1: 63,
    x2: 32,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#fff"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0bb1d3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_1_)"
    },
    d: "M7,21h4v2H7V21z M63,4v10c0,1.654-1.346,3-3,3h-3v2h2v2h-5v12h-4.706  c0.302,0.626,0.518,1.296,0.622,2H56v10h7v18H47V45h7v-8h-4.08c-0.488,3.386-3.401,6-6.92,6H21c-3.859,0-7-3.141-7-7h-2v9h6  c1.654,0,3,1.346,3,3v9h2v3c0,1.654-1.346,3-3,3H4c-1.654,0-3-1.346-3-3v-3h2v-9c0-1.654,1.346-3,3-3h4V34h4.315  c0.217-0.723,0.546-1.393,0.972-2H8v-5H4c-1.654,0-3-1.346-3-3V4c0-1.654,1.346-3,3-3h10c1.654,0,3,1.346,3,3v20  c0,1.654-1.346,3-3,3h-4v3h7.414c0.643-0.385,1.35-0.677,2.111-0.84C20.693,26.092,23.681,24,27,24c1.126,0,2.236,0.24,3.262,0.701  C31.719,22.424,34.263,21,37,21c4.411,0,8,3.589,8,8c0,0.098-0.002,0.196-0.007,0.297c1.1,0.329,2.082,0.924,2.88,1.703H52V21h-5v-2  h2v-2h-3c-1.654,0-3-1.346-3-3V4c0-1.654,1.346-3,3-3h14C61.654,1,63,2.346,63,4z M15,7H3v10h12V7z M3,4v1h12V4c0-0.552-0.448-1-1-1  H4C3.448,3,3,3.448,3,4z M4,25h10c0.552,0,1-0.448,1-1v-5H3v5C3,24.552,3.448,25,4,25z M21,59H3v1c0,0.552,0.448,1,1,1h16  c0.552,0,1-0.448,1-1V59z M18,47H6c-0.552,0-1,0.448-1,1v9h14v-9C19,47.448,18.552,47,18,47z M61,61v-6H49v6H61z M61,47H49v6h12V47z   M48,36c0-2.445-1.823-4.567-4.241-4.936l-0.989-0.15l0.151-0.989C42.975,29.57,43,29.276,43,29c0-3.309-2.691-6-6-6  c-2.315,0-4.447,1.36-5.432,3.467l-0.476,1.017l-0.955-0.589C29.188,26.31,28.104,26,27,26c-2.65,0-5.019,1.779-5.759,4.326  l-0.185,0.635L20.4,31.04C17.892,31.34,16,33.472,16,36c0,2.757,2.243,5,5,5h22C45.757,41,48,38.757,48,36z M45,4v7h16V4  c0-0.552-0.448-1-1-1H46C45.448,3,45,3.448,45,4z M55,17h-4v2h4V17z M61,14v-1H45v1c0,0.552,0.448,1,1,1h14  C60.552,15,61,14.552,61,14z M53,49h-2v2h2V49z M57,59h2v-2h-2V59z M59,49h-4v2h4V49z M51,59h4v-2h-4V59z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrp);
export default __webpack_public_path__ + "static/media/crp.14116c5e03f615e7e0f3642e7cfd0f99.svg";
export { ForwardRef as ReactComponent };